import CryptoJS from "crypto-js";
import {YEK_SEA} from "@/config/comm";


export const aesUtil= {
    /**
     * AES加密方法
     * @param text
     * @returns {string}
     */
    _encryptText: (text) => {
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let readyText = CryptoJS.enc.Utf8.parse(text);
        let encryptedText = CryptoJS.AES.encrypt(readyText, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encryptedText.toString();
    },
    /**
     * AES 解密方法
     * @param text
     * @returns {*}
     */
    _decryptText: (text) => {
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let decryptText = CryptoJS.AES.decrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decryptText).toString();
    },
}